module.exports = __webpack_public_path__ + "img/ic_stopwatch.5664d371.svg";